module.exports = __webpack_public_path__ + "static/media/8S.497eed1e.png";